/**
 * Theme Management — TASK-10
 *
 * Handles dark mode state and persistence.
 */

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'tibo-theme';

/**
 * Detects the initial theme based on localStorage or system preference.
 */
export function getInitialTheme(): Theme {
  const stored = localStorage.getItem(STORAGE_KEY) as Theme | null;
  if (stored) return stored;

  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }

  return 'light';
}

/**
 * Applies the theme to the document root and persists it.
 */
export function applyTheme(theme: Theme) {
  const root = window.document.documentElement;

  if (theme === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }

  localStorage.setItem(STORAGE_KEY, theme);
}

/**
 * Helper to set and apply theme in one call.
 */
export function setTheme(theme: Theme) {
  applyTheme(theme);
}
